import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import AddInsurance from "./addInsurance"

const AddInusranceContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
          <AddInsurance />
        </>
      </div>
    </div>
  )
}

export default AddInusranceContainer